import { type Dispatch, useContext } from "react";
import {
  CategoryTreeAction,
  CategoryTreeContext,
  CategoryTreeDispatch,
  CategoryTreeState,
} from "src/contexts/category-tree-context";

export function useCategoryTreeContext(): CategoryTreeState {
  const categoryTreeContext = useContext(CategoryTreeContext);

  if (!categoryTreeContext) {
    throw new Error(
      "Please make sure you use useCategoryTreeContext inside CategoryTreeProvider."
    );
  }

  return categoryTreeContext;
}
export function useCategoryTreeDispatch(): Dispatch<CategoryTreeAction> {
  const categoryTreeDispatch = useContext(CategoryTreeDispatch);

  if (!categoryTreeDispatch) {
    throw new Error(
      "Please make sure you use useCategoryTreeDispatch inside CategoryTreeProvider."
    );
  }

  return categoryTreeDispatch;
}
